import React from 'react'
import SubUsersTableHeaders from './SubUsersTableHeaders'
import SubUsersTableBody from '../SubUsersTableBody.jsx/SubUsersTableBody'

export default function SubUsersTable({BodyData , id}) {
  return (
    <>
      <div className="bg-white-rounded-top mt-3 table-parent">
			<div className={`table`}>
				<SubUsersTableHeaders />
				<div className="table-body">
					<SubUsersTableBody data={BodyData} id={id}/>
				</div>
			</div>
		</div>
    </>
  )
}
